import { render, staticRenderFns } from "./newCampaign.vue?vue&type=template&id=e68ef3f6&scoped=true&"
import script from "./newCampaign.vue?vue&type=script&lang=js&"
export * from "./newCampaign.vue?vue&type=script&lang=js&"
import style0 from "./newCampaign.vue?vue&type=style&index=0&id=e68ef3f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68ef3f6",
  null
  
)

export default component.exports